import React from "react";

export const SettingsContext = React.createContext({});

class SettingsContextProvider extends React.PureComponent {
  state = {
    theme: "light",
    player: "cross",
  };

  changeSettings = (key, newValue) => {
    this.setState((state) => {
      const next = { ...state, [key]: newValue };
      localStorage.setItem("tictacblast:settings", JSON.stringify(next));
      return next;
    });
  };

  componentDidMount() {
    const storedSettings = localStorage.getItem("tictacblast:settings");
    if (!storedSettings) return;
    const stored = JSON.parse(storedSettings);
    delete stored.hint;
    localStorage.setItem("tictacblast:settings", JSON.stringify(stored));
    this.setState(stored);
  }

  render() {
    return (
      <SettingsContext.Provider
        value={{ ...this.state, changeSettings: this.changeSettings }}
      >
        {this.props.children}
      </SettingsContext.Provider>
    );
  }
}

export default SettingsContextProvider;
